import {
  COMPOSITION_V4,
  type CompositionV4Query,
  type CompositionV4QueryVariables,
  type CompositionV4Req,
} from '@revelio/data-access';

import type { DataProviderResult } from '../DataProvider/types';
import { useUrqlQueryWithStatus } from '../DataProvider/utils/data-provider-results-utils';
import type { CompositionV4Metric } from '../PageConfigProvider/types/metric';

export type CompositionV4Response = NonNullable<
  CompositionV4Query['composition_v4']
>;

const COMPOSITION_V4_CONTEXT = { defersLowPriority: false };

export const compositionV4MetricSelection = (
  metrics: readonly CompositionV4Metric[]
): Omit<CompositionV4QueryVariables, 'req'> => ({
  headcount: metrics.includes('headcount'),
  hiring_rate: metrics.includes('hiring_rate'),
  attrition_rate: metrics.includes('attrition_rate'),
  growth_rate: metrics.includes('growth_rate'),
  tenure: metrics.includes('tenure'),
  salary: metrics.includes('salary'),
});

export const useCompositionV4Query = ({
  req,
  metrics,
  pause,
}: {
  req: CompositionV4Req;
  metrics: readonly CompositionV4Metric[];
  pause: boolean;
}): DataProviderResult<CompositionV4Response> => {
  const [{ data, status, error }] = useUrqlQueryWithStatus<
    CompositionV4Query,
    CompositionV4QueryVariables
  >({
    query: COMPOSITION_V4,
    variables: { req, ...compositionV4MetricSelection(metrics) },
    pause,
    context: COMPOSITION_V4_CONTEXT,
  });

  return {
    data: data?.composition_v4 ?? undefined,
    status,
    error: error ?? undefined,
  };
};
